export default "__VITE_ASSET__C9ZSUQ9G__"